import styled from "styled-components/native"

const CalendarSheetRightColumn = styled.View`
  height: 100%;
  flex: 1;
`

export default CalendarSheetRightColumn
